import React from 'react';
import { useFormik } from 'formik';
import { useState } from 'react';
import axios from 'axios';


const PlantTree = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [submitError, setSubmitError] = useState('');
    const formik = useFormik({
        initialValues: {
            firstname: '',
            middlename: '',
            lastname: '',
            email: '',
            phone: '',
            dob: '',
            ssnno: '',
            address: '',
            postalcode: '',
            applicationtype: '',
            experience: ''
        },
        validate: values => {
            const errors = {};
            if (!values.firstname) errors.firstname = "First name is required";
            if (!values.lastname) errors.lastname = "Last name is required";
            if (!values.email) {
                errors.email = "Email is required";
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.email = "Invalid email address";
            }
            if (!values.phone) errors.phone = "Phone number is required";
            if (!values.dob) errors.dob = "Date of birth is required";
            if (!values.ssnno) errors.ssnno = "SSN/SIN is required";
            if (!values.address) errors.address = "Address is required";
            if (!values.postalcode) errors.postalcode = "Postal code is required";
            if (!values.applicationtype) errors.applicationtype = "Job Application Type is required";
            if (!values.experience) errors.experience = "Years of Experience is required";
            return errors;
        },
        onSubmit: async values => {
            setIsSubmitting(true);
            setSubmitError('');
            setSubmitSuccess(false);

            try {
                const response = await axios.post(
                    // 'http://localhost:8080/mann/careerPost.php',
                    'https://manncarriers.com/server/careerPost.php',
                    values,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (response.data.success) {
                    setSubmitSuccess(true);
                    formik.resetForm();
                } else {
                    setSubmitError(response.data.message || 'Submission failed. Please try again.');
                }
            } catch (error) {
                console.error('Submission error:', error);
                setSubmitError('Something went wrong. Please try again.');
            } finally {
                setIsSubmitting(false);
            }
        }
    });
    return (
        <>
            <div id="hero" class="Starter section dark-background">
                <img src="assets/img/image5.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" data-aos="fade-in" />
                <div class="container">
                    <div class="row justify-content-center text-center" data-aos="fade-up" data-aos-delay="100">
                        <div class="col-xl-6 col-lg-8">
                            <h2>Grow Green with Every Mile<span>.</span></h2>
                            <p>Support reforestation through every delivery with Mann Carriers LLC.</p>
                        </div>
                    </div>
                </div>
            </div>
            <section className="green-legacy-program py-5">
                <div className="container">

                    <div class="container section-title pb-3 mt-5" data-aos="fade-up">
                        <h2>Plant a Tree</h2>
                        <p>Plant a Tree, Leave a Legacy</p>
                        <span >At Mann Carriers LLC, we care about growth — in business and in the environment. That's why we've launched our "Plant a Tree, Leave a Legacy" program to give employees the chance to make a real, lasting impact.</span>
                    </div>


                    <section id="features" className="features section mb-5">
                        <div className="container">
                            <div className="row g-5">
                                <div className="features-image col-lg-6" data-aos="fade-up" >
                                    <img src="assets/img/lighroom/tree1.jpg" />
                                </div>
                                <div className="col-lg-6">
                                    <h4 className="display-6 fw-bold ms-3 mb-3" data-aos="fade-up" data-aos-delay="200">Plant a Tree, Leave a Legacy</h4>
                                    <div className="features-item d-flex ps-0 ps-lg-3 pt-4 pt-lg-0" data-aos="fade-up" data-aos-delay="200">
                                        <div>
                                            <h4>What Is It?</h4>
                                            <p className="mb-0 text-muted fs-5">Employees are invited to plant 5 or more trees in meaningful locations — at home, in communities, or public spaces (with permission) — and care for them until they are healthy and self-sustaining.</p>
                                            <p className="mb-0 text-muted fs-5">But this isn't just planting. It's about adopting, naming, and owning your contribution to the planet.</p>
                                        </div>
                                    </div>

                                    <div className="features-item d-flex mt-3 ps-0 ps-lg-3" data-aos="fade-up" data-aos-delay="300">
                                        <div>
                                            <h4>How to Participate:</h4>
                                            <ul className="list-unstyled">
                                                <li className="mb-2">• Plant at least 5 trees</li>
                                                <li className="mb-2">• Name each tree and add a name tag or plate</li>
                                                <li className="mb-2">• Take photos at three stages: planting, mid-growth, and after 4–6 months</li>
                                                <li className="mb-2">• Submit a short write-up:
                                                    “Why I planted these trees and what they mean to me”</li>
                                                <li className="mb-2">• Send to: <a href="mailto:info@manncarriers.com">info@manncarriers.com</a></li>

                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>




                    <div className="row g-4 mb-5">
                        <div className="col-lg-4">
                            <div className="rewards-card h-100 p-4 bg-light rounded">
                                <h3 className="mb-4">Rewards for Participation:</h3>
                                <ul className="list-unstyled">
                                    <li className="mb-2">2 Paid Green Leave Days</li>
                                    <li className="mb-2">🏅 Personalized "Legacy Planter" Certificate & Plaque</li>
                                    <li className="mb-2">📸 Featured in our Employee Eco Wall of Fame</li>
                                    <li>🎁 Tree Adoption Kit for your home, with a pot labeled "Planted by [Your Name]"</li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="rewards-card h-100 p-4 bg-light rounded">
                                <h3 className="mb-4">Bonus: Team Participation</h3>
                                <p>Form a group and plant a mini forest! Teams of up to 3 can apply together and get:</p>
                                <ul className="list-unstyled">
                                    <li className="mb-2">🎉 Team Eco Award</li>
                                    <li>🥳 Company-sponsored eco-day outing</li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="rewards-card h-100 p-4 bg-light rounded">
                                <h3 className="mb-4">Year-End Recognition:</h3>
                                <p>At the end of the year, the best tree story and healthiest plantation will earn the title of "Green Guardian of the Year" with:</p>
                                <ul className="list-unstyled">
                                    <li className="mb-2">Trophy + featured story in company report</li>
                                    <li>Surprise gifts</li>
                                </ul>
                            </div>
                        </div>
                    </div>




                    {/* <div className="row">
                        <div className="col-12 text-center">
                            <a className="tree-btn btn-lg px-5 py-3" href='#tree-text'>
                                Get Started – Grow Your Legacy
                            </a>
                        </div>
                    </div> */}
                </div>



            </section>






        </>
    );
};
export default PlantTree;
